import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ep-ol ep-ol-static" }
const _hoisted_2 = { class: "ep-side-n" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "ep-side-h",
      style: {"margin-top":"18px"}
    }, "Activity", -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
        _createElementVNode("path", { d: "M8 9h8M8 13h6M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-5l-5 3v-3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h12z" })
      ], -1)),
      _createTextVNode(_toDisplayString(_ctx.comments.length) + " comment" + _toDisplayString(_ctx.comments.length == 1 ? '' : 's'), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments.slice(0, 2).reverse(), (comment) => {
      return (_openBlock(), _createElementBlock("div", {
        key: comment.ID,
        class: "ep-cmt"
      }, [
        _createElementVNode("b", null, _toDisplayString(`${comment.User}`.split(' ')[0]), 1),
        _createTextVNode(" " + _toDisplayString(`${comment.Comment}`.slice(0, 90)), 1)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
        _createElementVNode("path", { d: "M3 17c3.33-3.33 5-6 5-8a3 3 0 0 0-6 0c0 3 3 4.5 4.5 6.5C7.5 16.8 8.3 18 9 18c1.5 0 2.5-3 3-3s1 2 2.5 2c.6 0 1.6-.6 2.5-2M17 20h4" })
      ], -1)),
      _createTextVNode(_toDisplayString(_ctx.signedCount) + " of " + _toDisplayString(_ctx.requiredCount) + " signed v" + _toDisplayString(_ctx.version), 1)
    ])
  ], 64))
}